export const TwoSidesRendererName = 'twoSidesRendererComponent';
